<template>
  <div id="app" @click="appClick">
    <navigator></navigator>
    <router-view class="desktop"></router-view>
    <transition name="fade">
      <Certification v-if="loginModalShow" @confirm="loginConfirm" @cancel="loginCancel"/>
      <risk-tips-alert v-if="riskModalShow" :level="level" :pid="pid" @confirm="riskConfirm"></risk-tips-alert>
    </transition>
    <div class="layout-footer" v-if="site.address || site.linkPhone || site.linkEmail || site.beian">
      <p style="font-size: 1.1rem;" v-if="site.address">地址:&nbsp;{{ site.address }}</p>
      <p style="padding-top: 4px; font-size: 1rem;" v-if="site.linkPhone || site.linkEmail">
        <span v-if="site.linkPhone">电话: {{ site.linkPhone }}</span>
        <span v-if="site.linkEmail">邮箱: {{ site.linkEmail }}</span>
      </p>
      <p style="padding-top: 4px; font-size: 1rem;" v-if="site.beian">
        <span><a style="color: #e6e6e6;text-decoration: none" href="http://www.miitbeian.gov.cn">备案号：{{ site.beian }}</a></span>
      </p>
    </div>
  </div>
</template>

<script>
import Navigator from '@/components/commons/Navigator'
import Certification from './components/commons/Certification'
import RiskTipsAlert from '@/components/commons/RiskTipsAlert'
import bus from '@/utils/bus'
import API from '@/utils/api'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loginModalShow: false,
      riskModalShow: false,
      level: '',
      pid: '',
      // site: {"linkPhone":12901, "id":7,"template":{"name":"棕色","code":"A04","url":"..."},"logo":"attachment/20180329111332100.png","site":{"id":13,"index_img":"articlefile/2018040214170024.png","article_img":"articlefile/2018033013410284.png","product_img":"articlefile/2018033013420476.png","company_img":"articlefile/2018033013424023.png","web_index_img":"articlefile/web_home_bg.jpg","web_article_img":"articlefile/web_news_bg.jpg","web_product_img":"articlefile/web_product_bg.jpg","web_company_img":"articlefile/web_company_bg.jpg","index_title":"世域投资","index_desc":"<!DOCTYPE html>\n<html>\n<head>\n</head>\n<body>\n<p>始终专注基金行业，所有产品更稳健，更便捷，更专业。<br data-mce-bogus=\"1\"></p>\n</body>\n</html>","article_title":"资讯快报","article_desc":"<!DOCTYPE html>\n<html>\n<head>\n</head>\n<body>\n<p>企业新闻、行业分享<br data-mce-bogus=\"1\"></p>\n</body>\n</html>","product_title":"旗下产品","product_desc":"","company_title":"走进世域投资","company_desc":"<!DOCTYPE html>\n<html>\n<head>\n</head>\n<body>\n<p>诚信、务实、合作、创新、共赢<br data-mce-bogus=\"1\"></p>\n</body>\n</html>","web_company_desc":""},"name":"上海世域投资管理有限公司","short_name":"世域投资","fund_type":0,"service_phone":"021-68369731","link_user":null,"link_phone":"021-68369731","link_email":"","address":"上海市浦东新区浦东南路855号11楼B座","website":"","beian":"沪ICP备15008023号","domain_url":null,"wechat":"","file":null,"key":"1819b573-3e70-4adc-95f1-d8a2b8a09787","created_at":"2018-02-24T11:31:29.539658","expiration_at":"2021-01-31","status":true}
    }
  },
  computed: {
    ...mapState(['site'])
  },
  mounted () {
    const vm = this
    bus.$on('unlogin', function ({ status }) {
      vm.loginModalShow = status
      if (status === true) {
        vm.riskModalShow = false
      }
    })
    bus.$on('tipsalert', function ({ status = false, pid = 0, level = ''}) {
      if (vm.$store.getters.isLogin()) {
        vm.riskModalShow = status
        if (vm.riskModalShow === true) {
          vm.loginModalShow = false
          
          vm.pid = pid
          vm.level = level
        }
      } else {
        bus.$emit('unlogin', { status: true })
      }
    })
  },
  methods: {
    appClick (event) {
      if (this.riskModalShow) {
        if (event.path.indexOf(document.getElementById('risk-tips-alert')) < 0) {
          bus.$emit('tipsalert', { status: false })
        }
      }
    },
    riskConfirm ({ pid }) {
      // console.log('product id: ', pid)
      API.productApply(pid).then((resp) => {
        // console.log(resp)
        bus.$emit('tipsalert', { status: false })
      })
    },
    loginConfirm () {
      this.$router.push('/profile/login')
      bus.$emit('unlogin', { status: false })
    },
    loginCancel () {
      bus.$emit('unlogin', { status: false })
    }
  },
  components: {
    Navigator,
    Certification,
    RiskTipsAlert
  }
}
</script>

<style>
body, p, ul, li, span {
  margin: 0;
  padding: 0;
}

body{
  overflow: scroll;
  overflow-x: auto;
  min-width: 1360px;
}

.clickable {
  cursor: pointer;
}

.unvisible-tips {
  font-size: 1.1rem;
  font-weight: 500;
  color: #9e9e9e;
  text-align: center;
  padding: 30px 0;
}

/* ::-webkit-scrollbar {
  width: 0px;
  height: 0px;
} */

ul {
  list-style: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: white;
  position: relative;
  width: 100%;
  font-size: 18px;
  min-height: 100vh;
  padding-bottom: 120px;
}

.desktop {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}

.page-container {
  margin: 16px auto;
  min-height: 100px;
}

.page-left {
  display: inline-block;
  width: 25%;
  vertical-align: top;
}

.page-right {
  display: inline-block;
  vertical-align: top;
  width: 75%;
  padding-left: 10px;
  box-sizing: border-box;
}

.has-border {
  border: 1px solid #d8d8d8;
  padding: 8px 10px;
  border-radius: 4px;
}

.page-right .has-border{
  padding: 16px 20px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.75s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in below version 2.1.8 */ {
  opacity: 0;
}

.layout-footer {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  margin-top: 100px;
  font-family: arvo;
  color: #e6e6e6;
  font-size: 1rem;
  padding: 24px 0;
  background-color: #3a3a3a;
}

</style>



// WEBPACK FOOTER //
// src/App.vue